import { Component, AfterViewInit, ElementRef, Input, ViewChild } from '@angular/core';

const JsBarcode = require('jsbarcode');

@Component({
  selector: 'barcode',
  template: `
    <svg #svg></svg>
    `
})
export class BarcodeComponent implements AfterViewInit {
  @ViewChild('svg') private svg: ElementRef;

  @Input() data: string;

  constructor() { }

  ngAfterViewInit() {
    JsBarcode(this.svg.nativeElement, this.data);
  }

}
